import $ from 'jquery'
import mousetrap from 'mousetrap'
import mousetrapGlobalBind from 'mousetrap-global-bind'

export default function(o){

  mousetrap.bind('mod+shift+right',function(){
    if(o.video){
      if(o.playing && o.looping){
        o.loopStart = o.loopStart + 1 / 24
      } else {
        if(o.playing){
          o.controls.stop.click()
        }
        o.loopStart = o.video.currentTime + 1 / 24
        o.video.currentTime += 1 / 24
      }
      return false
    }
  })

  mousetrap.bind('shift+right',function(){
    if(o.video){
      if(o.playing && o.looping){
        o.loopStart = o.loopStart + 1
      } else {
        if(o.playing){
          o.controls.stop.click()
        }
        o.loopStart = o.video.currentTime + 1
        o.video.currentTime += 1
      }
      return false
    }
  })

  mousetrap.bind('right',function(){
    if(o.video){
      if(o.playing && o.looping){
        o.loopStart = o.loopStart + 10
      } else{
        if(o.playing){
          o.controls.stop.click()
        }
        o.loopStart = o.video.currentTime + 10
        o.video.currentTime += 10
      }
      return false
    }
  })

  mousetrap.bind('mod+shift+left',function(){
    if(o.video){
      if(o.playing && o.looping){
        o.loopStart = o.loopStart - 1 / 24
      } else{
        if(o.playing){
          o.controls.stop.click()
        }
        o.loopStart = o.video.currentTime - 1 / 24
        o.video.currentTime -= 1 / 24
      }
      return false
    }
  })

  mousetrap.bind('shift+left',function(){
    if(o.video){
      if(o.playing && o.looping){
        o.loopStart = o.loopStart - 1
      } else{
        if(o.playing){
          o.controls.stop.click()
        }
        o.loopStart = o.video.currentTime - 1
        o.video.currentTime -= 1
      }
      return false
    }
  })

  mousetrap.bind('left',function(){
    if(o.video){
      if(o.playing && o.looping){
        o.loopStart = o.loopStart - 10
      } else{
        if(o.playing){
          o.controls.stop.click()
        }
        o.loopStart = o.video.currentTime - 10
        o.video.currentTime -= 10
      }
      return false
    }
  })

  mousetrap.bind('space',function(){
    if(o.video){
      if(!o.playing){
        o.playing = true
        o.controls.play.hide()
        o.controls.stop.show()
        o.video.play()
      } else {
        o.playing = false
        o.controls.play.show()
        o.controls.stop.hide()
        o.video.pause()
      }
    }
    return false
  })

  mousetrap.bindGlobal('shift+enter',function(){
    var last = o.container.find('.mousetrapShiftEnter').last()
    if(last){
      last.click()
    }
    return false
  })

  mousetrap.bindGlobal('esc',function(){
    var last = o.container.find('.mousetrapEsc').last()
    if(last){
      last.click()
    }
    return false
  })

}



// WEBPACK FOOTER //
// ./src/client/view/admin/player/shortcuts/shortcuts.js